<template>
  <nav id="mainNav" role="navigation">
    <div id="displayContainer">
      <div class="header-right">
        <button class="logout-btn" id="helpButton" @click="openHelpMenu">{{ translate('help').toUpperCase()}}</button>
      </div>
    </div>
  </nav>
</template>

<script>
import {translate} from '../../assets/common/lang';

export default {
  props: ["mainConfig", "navbarData","getDisabledConfirm"],
  methods: {
    openHelpMenu() {
      this.$emit("openHelpMenu");
    },
    translate(word) {
      return translate(word);
    },
  }
};
</script>
